export var LOGIN_REQUEST = 'appspotr/Root/LOGIN_REQUEST';
export var LOGIN_SUCCESS = 'appspotr/Root/LOGIN_SUCCESS';
export var LOGIN_FAILED = 'appspotr/Root/LOGIN_FAILED';
export var LOGIN_REQUEST_2FA = 'appspotr/Root/LOGIN_REQUEST_2FA';
export var LOGOUT = 'appspotr/Root/LOGOUT';
export var SIGNUP_FAILED = 'appspotr/Root/SIGNUP_FAILED';
export var RESET_PASSWORD_SUCCESS = 'appspotr/Root/RESET_PASSWORD_SUCCESS';
export var RESET_PASSWORD_FAILED = 'appspotr/Root/RESET_PASSWORD_FAILED';
export var RESET_PASSWORD_REQUEST = 'appspotr/Root/RESET_PASSWORD_REQUEST';
export var LOAD_USER_PROFILE = 'appspotr/Root/LOAD_USER_PROFILE';
export var LOAD_USER_ORGANIZATIONS = 'appspotr/Root/LOAD_USER_ORGANIZATIONS';
export var LOAD_APP_WRITE_ORGANIZATIONS = 'appspotr/Root/LOAD_APP_WRITE_ORGANIZATIONS';
export var LOAD_LATEST_TERM = 'appspotr/Root/LOAD_LATEST_TERM';
export var LOAD_LATEST_POLICY = 'appspotr/Root/LOAD_LATEST_POLICY';
export var LOAD_APPS = 'appspotr/Root/LOAD_APPS';
export var LOAD_APPS_SUCCESS = 'appspotr/Root/LOAD_APPS_SUCCESS';
export var LOAD_APPS_EMPTY_SUCCESS = 'appspotr/Root/LOAD_APPS_EMPTY_SUCCESS';
export var LOAD_APPS_FAILED = 'appspotr/Root/LOAD_APPS_FAILED';
export var LOAD_ALL_ORG_APPS = 'appspotr/Root/LOAD_ALL_ORG_APPS';
export var LOAD_ALL_ORG_APPS_SUCCESS = 'appspotr/Root/LOAD_ALL_ORG_APPS_SUCCESS';
export var LOAD_ALL_ORG_APPS_FAILED = 'appspotr/Root/LOAD_ALL_ORG_APPS_FAILED';
export var LOAD_ORG_APPS = 'appspotr/Root/LOAD_ORG_APPS';
export var LOAD_ORG_APPS_SUCCESS = 'appspotr/Root/LOAD_ORG_APPS_SUCCESS';
export var LOAD_ORG_APPS_FAILED = 'appspotr/Root/LOAD_ORG_APPS_FAILED';
export var CREATE_APP_TEMPLATE = 'appspotr/Root/CREATE_APP_TEMPLATE';
export var CREATE_APP_TEMPLATE_SUCCESS = 'appspotr/Root/CREATE_APP_TEMPLATE_SUCCESS';
export var CREATE_APP_TEMPLATE_FAILED = 'appspotr/Root/CREATE_APP_TEMPLATE_FAILED';
export var UPDATE_APP_TEMPLATE = 'appspotr/Root/UPDATE_APP_TEMPLATE';
export var UPDATE_APP_TEMPLATE_SUCCESS = 'appspotr/Root/UPDATE_APP_TEMPLATE_SUCCESS';
export var UPDATE_APP_TEMPLATE_FAILED = 'appspotr/Root/UPDATE_APP_TEMPLATE_FAILED';
export var GO_TO_APP_DETAIL = 'app/AppDetail/GO_TO_APP_DETAIL';
export var GO_TO_ORG = 'app/AppDetail/GO_TO_ORG';
export var SECONDARY_SIDEBAR_STATE = 'app/AppDetail/SECONDARY_SIDEBAR_STATE';
export var MAIN_SIDEBAR_STATE = 'app/AppDetail/MAIN_SIDEBAR_STATE';
export var GO_TO_APP_NEW = 'app/AppDetail/GO_TO_APP_NEW';
export var GO_TO_APP_SETTINGS = 'app/AppDetail/GO_TO_APP_SETTINGS';
export var UPDATE_DASHBOARD = 'appspotr/Root/UPDATE_DASHBOARD';
export var CREATE_APP_SUCCESS = 'appspotr/Root/CREATE_APP_SUCCESS';
export var CREATE_APP_FAILED = 'appspotr/Root/CREATE_APP_FAILED';
export var CREATE_APP = 'appspotr/Root/CREATE_APP';
export var UPDATE_APP_SUCCESS = 'appspotr/Root/UPDATE_APP_SUCCESS';
export var UPDATE_APP_FAILED = 'appspotr/Root/UPDATE_APP_FAILED';
export var UPDATE_APP = 'appspotr/Root/UPDATE_APP';
export var SIGNAL_ROOT_INITIALIZED = 'appspotr/Root/SIGNAL_ROOT_INITIALIZED';
export var UPDATE_SIDEBAR_ITEMS = 'appspotr/Root/UPDATE_SIDEBAR_ITEMS';
export var SELECT_APP = 'appspotr/Root/SELECT_APP';
export var SELECT_ORGANIZATION = 'appspotr/Root/SELECT_ORGANIZATION';
export var LOAD_USER_GROUPS = 'appspotr/Root/LOAD_USER_GROUPS';
export var DELETE_APP_REQUEST = 'appspotr/Root/DELETE_APP_REQUEST';
export var DELETE_APP_SUCCESS = 'appspotr/Root/DELETE_APP_SUCCESS';
export var DELETE_APP_FAILURE = 'appspotr/Root/DELETE_APP_FAILURE';
export var SAVE_PASSWORD_SUCCESS = 'appspotr/Root/SAVE_PASSWORD_SUCCESS';
export var SAVE_PASSWORD_FAILURE = 'appspotr/Root/SAVE_PASSWORD_FAILURE';
export var SAVE_PASSWORD_REQUEST = 'appspotr/Root/SAVE_PASSWORD_REQUEST';
export var SET_PAGINATION = 'appspotr/Root/SET_PAGINATION';
export var SET_DEV_PLAN_MODAL_STATE = 'appspotr/Root/SET_DEV_PLAN_MODAL_STATE';
export var SET_MODAL_VISIBILITY_OVERRIDE = 'SET_MODAL_VISIBILITY_OVERRIDE';
export var LOAD_FILES_REQUEST = 'app/ViewBuilder/LOAD_FILES_REQUEST';
export var LOAD_FILES_SUCCESS = 'app/ViewBuilder/LOAD_FILES_SUCCESS';
export var LOAD_FILES_FAILURE = 'app/ViewBuilder/LOAD_FILES_FAILURE';
export var PLATFORM_VERSION_REQUEST = 'PLATFORM_VERSION_REQUEST';
export var PLATFORM_VERSION_SUCCESS = 'PLATFORM_VERSION_SUCCESS';
export var PLATFORM_VERSION_FAILURE = 'PLATFORM_VERSION_FAILURE';
export var GET_TEMPLATE_DATA = 'GET_TEMPLATE_DATA';
export var GET_TEMPLATE_DATA_SUCCESS = 'GET_TEMPLATE_DATA_SUCCESS';
export var GET_TEMPLATE_DATA_FAILURE = 'GET_TEMPLATE_DATA_FAILURE';
export var GET_APP_TEMPLATES = 'GET_APP_TEMPLATES';
export var GET_APP_TEMPLATES_SUCCESS = 'GET_APP_TEMPLATES_SUCCESS';
export var GET_APP_TEMPLATES_FAILURE = 'GET_APP_TEMPLATES_FAILURE';
export var DELETE_APP_TEMPLATES = 'DELETE_APP_TEMPLATES';
export var DELETE_APP_TEMPLATES_SUCCESS = 'DELETE_APP_TEMPLATES_SUCCESS';
export var DELETE_APP_TEMPLATES_FAILURE = 'DELETE_APP_TEMPLATES_FAILURE';
export var GET_TEMPLATE_CATEGORIES = 'GET_TEMPLATE_CATEGORIES';
export var GET_TEMPLATE_CATEGORIES_SUCCESS = 'GET_TEMPLATE_CATEGORIES_SUCCESS';
export var GET_TEMPLATE_CATEGORIES_FAILED = 'GET_TEMPLATE_CATEGORIES_FAILED';
export var CREATE_TEMPLATE_CATEGORY = 'CREATE_TEMPLATE_CATEGORY';
export var CREATE_TEMPLATE_CATEGORY_SUCCESS = 'CREATE_TEMPLATE_CATEGORY_SUCCESS';
export var CREATE_TEMPLATE_CATEGORY_FAILED = 'CREATE_TEMPLATE_CATEGORY_FAILED';
export var UPDATE_TEMPLATE_CATEGORY = 'UPDATE_TEMPLATE_CATEGORY';
export var UPDATE_TEMPLATE_CATEGORY_SUCCESS = 'UPDATE_TEMPLATE_CATEGORY_SUCCESS';
export var UPDATE_TEMPLATE_CATEGORY_FAILED = 'UPDATE_TEMPLATE_CATEGORY_FAILED';
export var DELETE_TEMPLATE_CATEGORY = 'DELETE_TEMPLATE_CATEGORY';
export var DELETE_TEMPLATE_CATEGORY_SUCCESS = 'DELETE_TEMPLATE_CATEGORY_SUCCESS';
export var DELETE_TEMPLATE_CATEGORY_FAILED = 'DELETE_TEMPLATE_CATEGORY_FAILED';
export var SET_OPEN_APP = 'appspotr/Root/SET_OPEN_APP';
export var SET_MAIN_SIDEBAR_STATE = 'SET_SIDEBAR_STATE';
export var SET_SEARCH_STRING = 'SET_SEARCH_STRING';
export var LOGIN_TOKEN_PROVIDED = 'appspotr/Root/LOGIN_TOKEN_PROVIDED';
export var UPDATE_ORG_TYPE = 'UPDATE_ORG_TYPE';
export var UPDATE_APP_FAVOURITE = 'UPDATE_APP_FAVOURITE';
export var LOAD_USAGE_APP = 'LOAD_USAGE_APP';
export var LOAD_USAGE_APP_SUCCESS = 'LOAD_USAGE_APP_SUCCESS';
export var LOAD_USAGE_APP_FAILED = 'LOAD_USAGE_APP_FAILED';
